var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('section',{staticClass:"about"},[_c('html-loader',{key:_vm.currentFile,attrs:{"filename":_vm.currentFile}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }